import { useTranslation } from "react-i18next";

import AnalyticsCard from "@/features/certifications/analytics/components/AnalyticsCard";
import {
  getFunnelBarHeight,
  getFunnelBars,
  toPercent,
} from "@/features/certifications/analytics/utils";
import { ModulesCardProps } from "@/features/certifications/analytics/types";

import "../styles.css";

const ParticipantFunnelCard = ({
  data,
  isLoading,
  isError,
}: ModulesCardProps) => {
  const { t } = useTranslation();
  const bars = data ? getFunnelBars(data) : [];
  const enrolled = data?.activeEnrollments ?? 0;

  return (
    <AnalyticsCard
      title={t("certification.admin.analytics.funnel.title")}
      info={t("certification.admin.analytics.funnel.info")}
      aside={
        <span className="analytics-muted body-s-regular">
          {t("certification.admin.analytics.funnel.enrolled", {
            count: enrolled,
          })}
        </span>
      }
      isLoading={isLoading}
      isError={isError}
    >
      <ol className="analytics-funnel flex items-end justify-between gap-200">
        {bars.map((bar) => {
          const label =
            bar.week === null
              ? t("certification.admin.analytics.funnel.enrolledStage")
              : t("certification.labels.week", { position: bar.week });

          return (
            <li
              key={bar.key}
              className="flex flex-1 flex-col items-center gap-100"
            >
              <span className="analytics-value body-s-medium">{bar.count}</span>

              <span
                className={`analytics-funnel-bar analytics-funnel-${bar.stage} full-width`}
                style={{ height: getFunnelBarHeight(bar.count, enrolled) }}
                aria-hidden
              />

              <span className="analytics-muted body-xs-regular">{label}</span>

              {bar.rate !== null && (
                <span className="analytics-muted body-xs-regular">
                  {t("certification.admin.analytics.percent", {
                    percent: toPercent(bar.rate),
                  })}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </AnalyticsCard>
  );
};

export default ParticipantFunnelCard;
